export const FAMILY_ADD_BUTTON_SX = {
  width: 200,
  height: 40,
  fontSize: '0.8rem',
  borderRadius: '8px',
  // FHButton renders its label in a nested Typography with its own font size.
  '& .MuiTypography-root': { fontSize: '0.75rem' },
};

export const FAMILY_SECTION_HEADING_SX = {
  textAlign: 'left',
  fontWeight: 'bold',
};

export const FAMILY_SECTION_LABEL_SX = {
  textAlign: 'left',
  fontWeight: 'bold',
  mb: 1,
};
